<div class="info-tooltip-container" @fadeIn (click)="onContainerClick()">
  <div #tooltipContent class="info-tooltip-content" [class.position-above]="direction === 'up'"
       [class.position-below]="direction === 'down'"
       [class.position-left]="direction === 'left'"
       [class.position-right]="direction === 'right'"
       [class.backdrop-disabled]="!backdropEnabled"
       [style.--arrow-offset-x]="arrowOffsetXPercent"
       [style.--arrow-offset-y]="arrowOffsetYPercent">
    
    <!-- Close button -->
    <button class="close-button" *ngIf="showCloseButton" (click)="onClose()" aria-label="Close tooltip">
      <ion-icon name="close"></ion-icon>
    </button>

    <!-- Arrow pointer -->
    <div class="tooltip-arrow"></div>

    <!-- Content -->
    <div class="tooltip-body" [class.no-close]="!showCloseButton">
      <!-- Simple text content -->
      <div *ngIf="content && !template" class="tooltip-text">
        {{ content }}
      </div>

      <!-- HTML template content -->
      <div *ngIf="template" class="tooltip-template">
        <ng-container *ngTemplateOutlet="template"></ng-container>
      </div>
    </div>

  </div>
</div>
